import type { WeeklyReviewContentV2 } from '@onflow/shared';

export interface VerdictBlockProps {
  content: WeeklyReviewContentV2;
  createdAt: string | null;
}

/**
 * Section 1 of /review V2 (spec: docs/features/review-page-v2.md §5.Section 1).
 * Lead-position coaching read: one AI sentence reusing the cron-generated
 * diagnosis, large type, no card chrome. When diagnosis is empty (no cron
 * run has landed yet for the current week) the slot renders a passive
 * cadence hint instead of a CTA — users no longer trigger reviews on
 * demand; the Sunday 21:00 IST cron is authoritative.
 */
export function VerdictBlock({ content, createdAt }: VerdictBlockProps) {
  const hasDiagnosis = content.diagnosis !== '';
  const meta =
    content.generatedBy === 'canned' ? 'Awaiting first week of logs' : formatGeneratedAt(createdAt);

  return (
    <section className="review-verdict" aria-label="Coach verdict">
      {hasDiagnosis ? (
        <>
          <p className="review-verdict__meta">{meta}</p>
          <p className="review-verdict__sentence">{content.diagnosis}</p>
        </>
      ) : (
        <p className="review-verdict__sentence review-verdict__sentence--placeholder">
          Your weekly review lands every Sunday at 9 PM IST.
        </p>
      )}
    </section>
  );
}

function formatGeneratedAt(iso: string | null): string {
  if (!iso) return 'Generated just now';
  const created = new Date(iso).getTime();
  const now = Date.now();
  const diffMs = Math.max(0, now - created);
  const dayMs = 24 * 60 * 60 * 1000;
  const days = Math.floor(diffMs / dayMs);
  if (days === 0) return 'Generated today';
  if (days === 1) return 'Generated 1 day ago';
  return `Generated ${days} days ago`;
}
